// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"MapComponent_mapContainer__3g2GJ","mapImage":"MapComponent_mapImage__tzoUg"};